import { Component, inject, Input } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { GlobalConfigService } from '../../../core/services/global-config.service';

@Component({
  selector: 'app-social-media',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './social-media.component.html',
  styleUrl: './social-media.component.scss'
})
export class SocialMediaComponent {
  @Input() color:string = '#334e85'
  @Input() size:number = 35;

  public globalConfig = inject(GlobalConfigService);
}
